/** One thumbnail: a rectangle of a sprite image, standing for a stretch of the movie. */
export interface SpriteTile {
  readonly startS: number;
  readonly file: string;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

function seconds(timestamp: string): number {
  const parts = timestamp.trim().split(':').map(Number);
  return parts.reduce((total, part) => total * 60 + part, 0);
}

/**
 * Reads a thumbnail WebVTT: each cue names an image and, after `#xywh=`, the
 * rectangle of it that shows that stretch. Cues it cannot read are skipped, so one
 * malformed line costs a tile rather than the strip.
 */
export function parseThumbnailVtt(text: string): ReadonlyArray<SpriteTile> {
  const tiles: SpriteTile[] = [];
  const lines = text.split(/\r?\n/).map((line) => line.trim());
  for (let index = 0; index < lines.length; index++) {
    const timing = /^([\d:.]+)\s+-->\s+([\d:.]+)/.exec(lines[index]);
    const target = lines[index + 1];
    if (timing === null || target === undefined) {
      continue;
    }
    const match = /^([^#]+)#xywh=(\d+),(\d+),(\d+),(\d+)$/.exec(target);
    if (match === null) {
      continue;
    }
    tiles.push({ startS: seconds(timing[1]), file: match[1], x: Number(match[2]), y: Number(match[3]), width: Number(match[4]), height: Number(match[5]) });
  }
  return tiles;
}
